// @ts-nocheck
// TypeScript is ignoring this file. If you are editing this file you must fix the type issues.

import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetchBills } from '../../../../hooks/useFetchBills';
import { BILLS_STATUSES } from '../../../../consts';
import { BILLS_TABLE_COLUMNS } from '../../components/BillsTable/consts';
import { BillsTable } from '../../components/BillsTable';
import { BILLS_TABLE_NAMES_TITLES } from '../../consts';
import { useStore } from '../../../../../../store';
import { mapBillsToBillsTableRow } from '../../utils';
import { scrollWebappToTop } from '../../../../../Invoices/InvoiceHub/utils';
import { AVAILABLE_BILL_MODALS } from '../../components/BillsModalsHub/consts';

export const PaidBills = () => {
  const paidBills = useStore(state => state.paidBills);
  const setPaidBills = useStore(state => state.setPaidBills);
  const pageNumber = useStore(state => state.paidBillsPageNumber);
  const setBillError = useStore(state => state.setBillError);
  const setActiveBillModal = useStore(state => state.setActiveBillModal);
  const [hasMoreToFetch, setHasMoreToFetch] = useState<boolean>(true);
  const totalPaidBills = useStore(state => state.totalPaidBills);
  const setTotalPaidBills = useStore(state => state.setTotalPaidBills);
  const { t } = useTranslation();
  const { refetch: fetchBills, isFetching } = useFetchBills({
    status: BILLS_STATUSES.PAID,
    pageNumber,
    sortBy: 'PAID_TIME',
    sortDirection: 'DESC',
    onSuccess: async (data: any) => {
      if (data?.results?.length === 0) {
        setHasMoreToFetch(false);
      } else {
        setPaidBills(data?.results, pageNumber > 0);
        setTotalPaidBills(data?.totalResults);
      }
    },
    onError: (e: any) => {
      setBillError(e);
      setActiveBillModal(AVAILABLE_BILL_MODALS.ERROR);
    },
  });
  useEffect(() => {
    setTimeout(() => {
      scrollWebappToTop();
    }, 0);
  }, []);

  useEffect(() => {
    if (hasMoreToFetch) {
      fetchBills();
    }
  }, [pageNumber]);
  const paidBillsRows = useMemo(() => mapBillsToBillsTableRow(paidBills), [paidBills]);
  return (
    <BillsTable
      title={`${t(BILLS_TABLE_NAMES_TITLES.PAID)} (${totalPaidBills})`}
      testId='BillsHub__paid-bills-table'
      columns={BILLS_TABLE_COLUMNS}
      tableName={t(BILLS_TABLE_NAMES_TITLES.PAID)}
      data={paidBillsRows}
      isLoading={isFetching && pageNumber === 0}
    />
  );
};
